.ReconcileRow {
    position: relative;
    display: grid;
    grid-template-columns: minmax(0, 1fr) 128px minmax(0, 1fr);
    gap: 12px;
    align-items: stretch;
    padding: 16px;
    animation: ReconcileRow-in 0.32s cubic-bezier(0.2, 0.7, 0.3, 1)
        backwards;

    /* Doubled class keeps this ahead of the GlassSurface card border. */
    &.isConflict {
        border-color: var(--soniq-t--global--border--color--status--danger--default);
    }
}

.ReconcileRow__stripe {
    position: absolute;
    left: 0;
    top: 14px;
    bottom: 14px;
    width: 3px;
    border-radius: 3px;
    background: var(--soniq-t--global--palette--hot-pink);
}

.ReconcileRow.isSkipped .ReconcileRow__source {
    opacity: 0.5;

    /* The record's name, marked by SourceCard */
    & [data-source-name] {
        text-decoration: line-through;
        text-decoration-thickness: 1px;
    }
}

.ReconcileRow__source,
.ReconcileRow__resolution {
    display: flex;
    flex-direction: column;
    gap: 10px;
    min-width: 0;
}

.ReconcileRow__alert {
    grid-column: 1 / -1;
}

@keyframes ReconcileRow-in {
    from {
        opacity: 0;
        transform: translateY(8px);
    }
    to {
        opacity: 1;
        transform: none;
    }
}

@media (max-width: 760px) {
    .ReconcileRow {
        grid-template-columns: 1fr;
        gap: 14px;
    }
}

@media (prefers-reduced-motion: reduce) {
    .ReconcileRow {
        animation: none;
    }
}
